var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0065FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.808 7.023c5.77-6.749 15.29-8.9 23.4-5.286 1.01.45 1.463 1.631 1.014 2.64-.45 1.01-1.632 1.463-2.641 1.013-6.492-2.892-14.114-1.17-18.732 4.232-4.618 5.403-5.132 13.199-1.264 19.16 3.869 5.963 11.198 8.67 18.014 6.656 6.704-1.982 11.34-8.07 11.495-15.03l.004-.35v-1.66c0-1.104.895-2 2-2 1.054 0 1.918.816 1.994 1.851l.006.15v1.661c-.006 8.879-5.85 16.696-14.365 19.214-8.514 2.517-17.67-.866-22.503-8.314-4.833-7.448-4.19-17.188 1.578-23.937z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.683 5.098c.781-.781 2.048-.781 2.829 0 .74.74.779 1.916.117 2.701l-.117.128-18.049 18.048c-.74.74-1.915.78-2.7.118l-.128-.117-5.414-5.41c-.782-.78-.782-2.046-.002-2.828.74-.74 1.915-.78 2.701-.118l.128.117 3.999 3.996L36.683 5.098z",
    transform: "translate(1 1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.45e7e6ab9db5d87f010b8b2541a8592c.svg";
export { ForwardRef as ReactComponent };